// Utils
import { elementHandlers } from './ElementHandlers';
import { tagHandlers } from './TagHandlers';
import { essenceHandlers } from './EssenceHandlers';
import { photoHandlers } from './PhotoHandlers';
import { linkHandlers } from './LinkHandlers';
import { historyHandlers } from './HistoryHandlers';
import { actionHandlers } from './ActionHandlers';
import { eventHandlers } from './EventHandlers';

// Gestionnaires d'opérations, un par type, ajoutés au fil des phases 1 à 3
export const getHandlers = () => ({
    ...elementHandlers,
    ...tagHandlers,
    ...essenceHandlers,
    ...photoHandlers,
    ...linkHandlers,
    ...historyHandlers,
    ...actionHandlers,
    ...eventHandlers
});
